import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      border: `1px solid ${theme.palette.background.gray_200}`,
      maxWidth: "433px",
      borderRadius: "12px",
    },
    card: {
      padding: "24px",
      borderRadius: "12px 12px 0 0 !important",
      maxWidth: "433px",
    },
    activityCard: {
      maxWidth: "433px",
      borderRadius: "12px !important",
      padding: "24px",
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
    },
    activityDetails: {
      display: "flex",
      flex: "1 1 50%",
      flexDirection: "column",
      gap: "8px",
      "& > *": {
        fontSize: "16px",
        fontWeight: 500,
        color: theme.palette.text.tertiary,
      },
      "&  * + *": {
        fontSize: "30px",
        fontWeight: 600,
        color: theme.palette.text.primary,
      },
    },
    aedIcon: {
      verticalAlign: "super",
      fill: theme.palette.text.tertiary,
    },
    avatarWrapper: {
      position: "relative",
      alignItems: "center",
      backgroundColor: "#FFF",
      borderRadius: theme.borderRadius[10],
      boxShadow: theme.shadows[4],
      display: "flex",
      height: "104px",
      width: "104px",
      justifyContent: "center",
    },
    defaultAvatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "96px",
      width: "96px",

      "& img": {
        height: "48px",
        width: "48px",
      },
    },
    avatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "96px",
      width: "96px",
      "& img": {
        objectFit: "contain",
      },
    },
    contactDetailsContainer: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    contactDetails: {
      display: "flex",
      gap: "8px",
      flexDirection: "column",
    },
    summaryContainer: {
      padding: "24px",
    },
    agentCard: {
      padding: "24px",
      borderRadius: "12px !important",
      maxWidth: "433px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    asideContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "24px",
    },
    actionsContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    actionsCard: {
      maxWidth: "433px",
      width: "100%",
      borderRadius: "12px !important",
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
  };
});
